import { Anchors } from '~/modules/Anchors';
import { CmAnchors } from '~/modules/CmAnchors';
import { MvSlider } from '~/modules/MvSlider';
import { InterviewSlider } from '~/modules/interviewSlider';
import { Sliders } from '~/modules/Slider';
import { IframeApi, Modal } from '~/modules/Modal';
import { ModalContents } from '~/modules/ModalContents';
import { CloseContent } from '~/modules/closeContent';
import { FixedNav } from '~/modules/fixedNav';
import { ShowMonitor } from '~/modules/showMonitor';
import { MaskImage } from '~/modules/maskImage';
import { DrugControl } from '~/modules/DrugControl';
import { ClickControl } from '~/modules/ClickControl';
import Splitting from 'splitting';
import { IS_SP, IS_PORTRAIT } from '~/const/config';

import IntersectionManager from '~/util/IntersectionManager';

/**
 * 全ページ共通の処理はここに書く
 */

export class CommonController {
  constructor() {
    this.init();
  }
  init() {
    /**
     * インスタンス生成時に実行したい処理をここ書く
     */
    Splitting();


    // IframeApi API
    new IframeApi();

    // 右クリック禁止
    new ClickControl();

    // ドラッグ禁止
    new DrugControl();

    // extends用処理
    this.handlerLoad = () => this.load();
    window.addEventListener('load', this.handlerLoad);
  }
  load() {
    /**
     * window読み込み時に実行したい処理をここ書く
     */
    document.body.classList.add('is-load-end');

    // アニメーション用 クラスを付与
    new IntersectionManager();

    // スライダー
    new MvSlider();
    new InterviewSlider();
    new Sliders();

    // モーダル
    const $modal = document.querySelectorAll('.js-modal-openBtn');
    $modal.forEach((el) => {
      new Modal(el);
    });

    const $modalContents = document.querySelectorAll('.js-contents-openBtn');
    $modalContents.forEach((el) => {
      new ModalContents(el);
    });

    new CloseContent();


    new MaskImage();

    new ShowMonitor();


    // ここだけの話…
    new FixedNav();

    // アンカー
    new Anchors();
    
    // CMアンカー ※GSAPのpinの影響でスクロール量おかしくなるので
    new CmAnchors();
    
  }
}
